module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-9.1b556d1f.png";